<div class="list-breadcrumbs">
  <ng-container *ngFor="let breadcrumb of breadCrumbPage; let last = last">
    <div class="breadcrumb-item-link" (click)="onNavigateTo(breadcrumb.path, last)"
      [ngStyle]="{'cursor': last ? 'default' : 'pointer'}">
      <span class="breadcrumb-item-link-text" title="{{ breadcrumb.value }}">
        {{ breadcrumb.value.length > 25 ? breadcrumb.value.substring(0, 25) + '...' : breadcrumb.value }}
      </span>
      <mat-icon class="icon" *ngIf="!last">chevron_right</mat-icon>
    </div>
  </ng-container>
</div>